import { checkEnrichedName } from 'bto-models/utils/string';
/**
 * Outcome model for Match Details
 */
export default class MatchDetailsOutcomeModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor(data, homeTeam = '', guestTeam = '') {
    /**
     * is outcome active
     * @type {Boolean}
     */
    this.active = data.a;
    /**
     * Column number
     * @type {number}
     */
    this.column = data.col;
    /**
     * Odd type outcome identifier
     * @type {string}
     */
    if (!data.otoi) {
      this.otoIdentifier = undefined;
    } else {
      this.otoIdentifier = data.otoi;
    }
    /**
     * Live outcome Identifer
     * @type {string}
     */
    this.identifier = data.i;
    /**
     * Live outcome Specifier
     * @type {string}
     */
    this.specifier = data.sp;
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * Name
     * @type {string}
     */
    this.name = data.n && data.sbv && !data.eon ? `${data.n} (${data.sbv})` : data.n;
    /**
     * Original decimal value of outcome
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Order number (vertical position)
     * @type {number}
     */
    this.orderNo = data.ord;
    /**
     * Special bet value
     * @type {string}
     */
    this.sbv = data.sbv;
    /**
     * Update class, possible values are 0, 1, -1
     */
    this.upDownClass = typeof data.ud !== "undefined" ? data.ud : "";
    /**
     * Suspended outcome
     * @type {boolean}
     */
    this.suspended = data.su;
    /**
     * Enriched Outcome Names
     * @type {string}
     */
    this.enrichedOutcomeName = checkEnrichedName(data.eon, homeTeam, guestTeam, data.sbv);
  }
}
